import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LiliButton } from '@lili/lili-frontend-common';
import { GENERAL_STYLE, FORGOT_EMAIL_PAGE_DATA, FORGOT_PASSWORD_FLOW } from '../constants';
import LoginCard from '../../../components/LoginCard';
import Heading from '../../../../../generic-components/Heading';
import Button from '../../../../../generic-components/Button';
import { LoginHelpNavBar } from '../LoginHelpNavBar';
import { VIEWS_MAP } from '../../../../../router/constants';
import { Input } from '../../../../../generic-components/Input';
import { ValidateFieldTypes, validationSchemeMap } from '../../../../../helpers/inputUtils.helper';
import { Layout } from '../../../../../components/Layout/Layout';

interface IProps {
    initialInput: string;
    onSubmit: (email: string) => void;
    onClose: () => void
    onBack: () => void
}
const ForgotPasswordEmailInputStep = ({
  initialInput, onSubmit, onClose, onBack,
}: IProps) => {
  const { t } = useTranslation();
  const [emailInput, setEmailInput] = useState<string>(initialInput);
  const [invalidEmailMessage, setInvalidEmailMessage] = useState<string>('');
  const navigate = useNavigate();
  const emailRegex = validationSchemeMap[ValidateFieldTypes.EMAIL];
  function isValidEmail(email: string): boolean {
    return emailRegex.test(email);
  }
  const onButtonClick = () => {
    if (isValidEmail(emailInput)) {
      onSubmit(emailInput);
    } else {
      setInvalidEmailMessage(t(FORGOT_PASSWORD_FLOW.ERRORS.INVALID_EMAIL));
    }
  };
  const heading = (
    <Heading
      title={t(FORGOT_PASSWORD_FLOW.EMAIL_INPUT.TITLE)}
      className={`${GENERAL_STYLE.HEADING.CLASS_NAME} mb-[16px]`}
    />
  );
  const subtitle = (
    <Heading
      title={t(FORGOT_PASSWORD_FLOW.EMAIL_INPUT.SUBTITLE)}
      className={`${GENERAL_STYLE.DESCRIPTION.CLASS_NAME} mb-[40px]`}
    />
  );
  const mainButton = (
    <LiliButton
      id='mainButton'
      title={t(FORGOT_EMAIL_PAGE_DATA.CONTINUE_BUTTON_TITLE)}
      className={`${GENERAL_STYLE.MAIN_BUTTON.CLASS_NAME}`}
      onClick={onButtonClick}
      disabled={emailInput.length === 0}

    />
  );

  const forgotEmailButton = (
    <Button
      id='forgotEmailButton'
      title={t(FORGOT_PASSWORD_FLOW.EMAIL_INPUT.FORGOT_EMAIL_BUTTON)}
      className={`${GENERAL_STYLE.SECONDARY_BUTTON.CLASS_NAME} mb-[51px]`}
      onClick={() => {
        navigate(`/${VIEWS_MAP.RECOVERY}/email`);
      }}
    />
  );

  const emailInputField = (
    <Input
      id='emailInput'
      onFocus={() => {}}
      onChange={(data) => {
        setInvalidEmailMessage('');
        setEmailInput(data.value);
      }}
      title={t(FORGOT_PASSWORD_FLOW.EMAIL_INPUT.INPUT_TITLE)}
      type='email'
      error={invalidEmailMessage}
      isError
      validation={emailRegex}
      shouldValidate
      autocomplete='on'
    />
  );
  return (
    <Layout shouldHideProfile shouldHideChatBot wrapperClassName='pt-[78px] pl-[72px] ml-[100px] pc-md:ml-[256px]'>
      <LoginHelpNavBar
        onBackClick={onBack}
        onCloseClick={onClose}
      />

      <LoginCard className={GENERAL_STYLE.LOGIN_CARD.CLASS_NAME}>
        <div className='flex flex-col justify-between h-full'>

          <div className='mb-[62px]'>
            {heading}
            {subtitle}
            {emailInputField}
          </div>
          {forgotEmailButton}
          {mainButton}
        </div>
      </LoginCard>
    </Layout>

  );
};

export default ForgotPasswordEmailInputStep;
